import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { Workspace } from '../../@types/model/workspace';
import i18n from '../../i18n';
import { esSilosLang } from '../../i18n/workspaces/silos/es';
import { esDefaultLang } from '../../i18n/workspaces/default/es';
import { esRepsolLang } from '../../i18n/workspaces/repsol/es';
import { enSilosLang } from '../../i18n/workspaces/silos/en';
import { enDefaultLang } from '../../i18n/workspaces/default/en';
import { enRepsolLang } from '../../i18n/workspaces/repsol/en';
import { checkWorkspace, WORKSPACES_INGAFOOD, WORKSPACES_REPSOL } from 'guards/CheckRoles';
// ----------------------------------------------------------------------

type WorkspaceState = {
  loaded: boolean;
  isLoading: boolean;
  error: boolean;
  workspace: null | Workspace;
};

const initialState: WorkspaceState = {
  isLoading: false,
  loaded: false,
  error: false,
  workspace: null
};

const slice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.loaded = true;
      state.error = action.payload;
    },

    // GET PROFILE
    getWorkspaceSuccess(state, action) {
      state.isLoading = false;
      state.loaded = true;
      state.workspace = action.payload.data as Workspace;

      if (checkWorkspace(state.workspace, WORKSPACES_INGAFOOD)) {
        i18n.addResourceBundle('es', 'custom', esSilosLang);
        i18n.addResourceBundle('en', 'custom', enSilosLang);
      } else if (checkWorkspace(state.workspace, WORKSPACES_REPSOL)) {
        i18n.addResourceBundle('es', 'custom', esRepsolLang);
        i18n.addResourceBundle('en', 'custom', enRepsolLang);
      } else {
        i18n.addResourceBundle('es', 'custom', esDefaultLang);
        i18n.addResourceBundle('en', 'custom', enDefaultLang);
      }
      if (state.workspace.styles) {
        let obj = state.workspace.styles;
        Object.entries(obj).forEach(([key, value]) =>
          document.documentElement.style.setProperty('--' + key, value)
        );
      }
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { getWorkspaceSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function loadWorkspace() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/get-workspace');
      dispatch(slice.actions.getWorkspaceSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
